document.addEventListener("click", function(event) {
    // Check if the clicked element or its parent contains the 'siblings__swatch' class
    var swatch = event.target.closest('.siblings__swatch');

    if (swatch) {
        // Get the value of swatch-href, swatch-title, swatch-img, swatch-hover, swatch-price, and swatch-compare-price
        var swatchHref = swatch.getAttribute('swatch-href');
        var swatchTitle = swatch.getAttribute('swatch-title');
        var swatchImg = swatch.getAttribute('swatch-img');
        var swatchHover = swatch.getAttribute('swatch-hover');
        var swatchHandle = swatch.getAttribute('swatch-quick');
        var swatchPrice = swatch.getAttribute('swatch-price');
        var swatchComparePrice = swatch.getAttribute('swatch-compare-price');
        var swatchColor = swatch.getAttribute('swatch-color');
        var swatchClassName = swatch.getAttribute('class');

        var productItem = swatch.closest('.product-card');
        if (productItem) {
          console.log('color:' + swatchColor);          
            // Change the href of the anchor tag under .product-card__media
            var imageWrapperAnchor = productItem.querySelector('.product-card__media');
            if (imageWrapperAnchor) {
                imageWrapperAnchor.setAttribute('href', swatchHref);
            }

                const getAllbadges = productItem.querySelector('.badge-list');
                const checkSoldOutExist = productItem.querySelector('.badge');
                const metalNameElement = productItem.querySelector('.metal-name');

// פונקציה להסרת כל קלאסי הצבעים
function resetBadgeClasses(element) {
    element.classList.remove('badge-whitegold', 'badge-gold', 'badge-rose', 'badge-silver');
}

// תנאי ל-14K White Gold
if (swatchColor.includes('14k-white-gold')) {
    resetBadgeClasses(checkSoldOutExist); // הסר את כל הקלאסים הקיימים
    checkSoldOutExist.classList.add('badge-whitegold');
    if (metalNameElement) metalNameElement.textContent = 'זהב אמיתי 14K';
}

// תנאי ל-14K Yellow Gold
if (swatchColor.includes('14k-yellow-gold')) {
    resetBadgeClasses(checkSoldOutExist); // הסר את כל הקלאסים הקיימים
    checkSoldOutExist.classList.add('badge-gold');
    if (metalNameElement) metalNameElement.textContent = 'זהב אמיתי 14K';
}

// תנאי ל-14K Rose Gold
if (swatchColor.includes('14k-rose-gold')) {
    resetBadgeClasses(checkSoldOutExist); // הסר את כל הקלאסים הקיימים
    checkSoldOutExist.classList.add('badge-rose');
    if (metalNameElement) metalNameElement.textContent = 'זהב אמיתי 14K';
}

// תנאי ל-925 Sterling Silver
if (swatchColor.includes('925-sterling-silver')) {
    resetBadgeClasses(checkSoldOutExist); // הסר את כל הקלאסים הקיימים
    checkSoldOutExist.classList.add('badge-silver');
    if (metalNameElement) metalNameElement.textContent = 'כסף 925';
}

          
            if (swatchClassName == 'siblings__swatch siblings__swatch--sold-out') {
                if (checkSoldOutExist.classList.contains('badge--sold-out')) {
                    var showSoldOut = productItem.querySelector('.badge--sold-out');
                    showSoldOut.style.display = 'block';
                } else {
                    productItem.querySelectorAll('.badge--sold-out').forEach(function(element) {
                        element.remove();
                    });
                    getAllbadges.innerHTML += '<sold-out-badge class="badge badge--sold-out h-stack align-center justify-center gap-2"><span class="metal-circle"></span><span>אזל מהמלאי</span></sold-out-badge>';
                }
            } else {
                var hideSoldOut = productItem.querySelector('.badge--sold-out');
                if (hideSoldOut) {
                    hideSoldOut.style.display = 'none';
                }
            }

            // Change the href and text of the anchor tag under .product-title
            var titleAnchor = productItem.querySelector('.product-title');
            if (titleAnchor) {
                titleAnchor.setAttribute('href', swatchHref);
                titleAnchor.textContent = swatchTitle;
            }

            // Change the src, data-srcset, and srcset of the main product image
            var productImage = productItem.querySelector('.product-card__image--primary');
            if (productImage) {
                productImage.setAttribute('src', swatchImg);
                productImage.setAttribute('data-srcset', swatchImg);
                productImage.setAttribute('srcset', swatchImg);
            }

            // Change the src, data-srcset, and srcset of the hover product image
            var productImageAlternate = productItem.querySelector('.product-card__image--secondary');
            if (productImageAlternate) {
                productImageAlternate.setAttribute('src', swatchHover);
                productImageAlternate.setAttribute('data-srcset', swatchHover);
                productImageAlternate.setAttribute('srcset', swatchHover);
            }

            var quickhandle = productItem.querySelector('quick-buy-modal');
            if (quickhandle) {
                quickhandle.setAttribute('handle', swatchHandle);
            }

            // Change the price and compare-at-price of the product
            var priceElement = productItem.querySelector('sale-price');
            if (priceElement) {
                priceElement.textContent = swatchPrice;
            }

            var comparePriceElement = productItem.querySelector('compare-at-price');
            if (comparePriceElement) {
                comparePriceElement.textContent = swatchComparePrice;
            }

            // Remove aria-current="true" from previously selected swatch
            var previousSelectedSwatch = productItem.querySelector('.siblings__swatch[aria-current="true"]');
            if (previousSelectedSwatch) {
                previousSelectedSwatch.removeAttribute('aria-current');
            }

            // Add aria-current="true" to the clicked swatch
            swatch.setAttribute('aria-current', 'true');

            // Hide the .btn--quick div
            var quickBuyButton = productItem.querySelector('.btn--quick');
            if (quickBuyButton) {
                quickBuyButton.style.display = 'none';
            }
        }
    }
});
